/**
 * Auth API.
 *
 * NOTE: The backend currently has no /api/v1/auth/login endpoint. This file
 * calls the expected endpoint — it will work as soon as the backend adds a
 * matching route returning { access_token, user_id }.
 *
 * For immediate testing before that endpoint lands, set VITE_DEV_AUTH_TOKEN
 * in .env and the login page will short-circuit straight to the app using it.
 */
import { apiClient } from "./client";
import type { Me } from "@/types";

export interface LoginRequest {
  email: string;
  password: string;
}

export interface LoginResponse {
  access_token: string;
  token_type: string;
  user_id: string;
  clinic_id: string;  // returned by the backend so the frontend can scope requests
  expires_in: number;
}

export async function login(req: LoginRequest): Promise<LoginResponse> {
  const { data } = await apiClient.post<LoginResponse>("/api/v1/auth/login", req);
  return data;
}

export async function getMe(): Promise<Me> {
  const { data } = await apiClient.get<Me>("/api/v1/auth/me");
  return data;
}
